/** Artikel kopieren (Screen mieter/Artikel-kopieren): Vorlage, Anzahl, Bezeichnungen anpassen, „anlegen und Etiketten drucken“. */
import { useTx } from "../i18n";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { Button, Notice, Seitenzustand, TextField } from "../ui";
import { ItemRow } from "../ui/ItemRow";
import { ApiFehler } from "../api/client";
import { formatEuro } from "@shared/geld";
import { fotoUrl, useArtikelAnlegen, useMeinArtikel } from "./artikel-api";

export function Kopieren() {
  const tx = useTx();
  const { id = "" } = useParams();
  const q = useMeinArtikel(id);
  const anlegen = useArtikelAnlegen();
  const navigate = useNavigate();
  const [anzahl, setAnzahl] = useState(2);
  const [namen, setNamen] = useState<string[]>([]);
  const [mehr, setMehr] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  return (
    <Seitenzustand query={q} lines={4}>
      {({ artikel: a }) => {
        const sichtbar = mehr ? anzahl : Math.min(anzahl, 3);
        async function anlegenUndDrucken() {
          setFehler(null);
          try {
            const r = await anlegen.mutateAsync({ bezeichnung: a.bezeichnung, preisCent: a.preisCent, kategorie: a.kategorie, groesse: a.groesse, anzahl, bezeichnungen: Array.from({ length: anzahl }, (_, i) => namen[i] ?? ""), regalId: a.regalId });
            navigate(`/mieter/etiketten?ids=${r.artikel.map((x) => x.id).join(",")}`);
          } catch (err) {
            setFehler(err instanceof ApiFehler ? err.message : "Anlegen hat nicht geklappt.");
          }
        }
        return (
          <div className="sc-col" style={{ gap: "var(--space-4)" }}>
            <div className="sc-row">
              <Link to="/mieter/erfassen" className="rg-btn rg-btn--quiet" aria-label="Zurück">‹</Link>
              <h1 className="title">{tx("Artikel kopieren")}</h1>
            </div>
            <span className="sc-muted sc-small">Vorlage</span>
            <ItemRow title={a.bezeichnung} photo={fotoUrl(a.fotoKey)} meta={`${a.code}${a.kategorie ? ` · ${a.kategorie}` : ""}`} price={a.preisCent} />
            {fehler ? <Notice tone="error">{fehler}</Notice> : null}
            <div className="sc-spread">
              <span>Wie viele? <span className="sc-strong">{anzahl} × {formatEuro(a.preisCent)} = {formatEuro(anzahl * a.preisCent)}</span></span>
              <span className="sc-row">
                <Button variant="secondary" icon="minus" aria-label="Weniger" onClick={() => setAnzahl(Math.max(1, anzahl - 1))} />
                <span className="sc-strong" style={{ minWidth: 32, textAlign: "center" }}>{anzahl}</span>
                <Button variant="secondary" icon="plus" aria-label="Mehr" onClick={() => setAnzahl(Math.min(50, anzahl + 1))} />
              </span>
            </div>
            <h2 className="heading">{tx("Bezeichnungen anpassen")}</h2>
            <p className="sc-muted sc-small">Freiwillig. Leer lassen heißt: „{a.bezeichnung}“.</p>
            {Array.from({ length: sichtbar }, (_, i) => (
              <TextField key={i} label={`${i + 1}.`} value={namen[i] ?? ""} onChange={(e) => { const n = [...namen]; n[i] = e.target.value; setNamen(n); }} placeholder={a.bezeichnung} maxLength={80} />
            ))}
            {anzahl > 3 && !mehr ? <Button variant="quiet" iconEnd="chevron-right" onClick={() => setMehr(true)}>{anzahl - 3} weitere anzeigen</Button> : null}
            <div className="sc-phone__foot" style={{ position: "sticky", bottom: 72, margin: "0 calc(-1 * var(--space-4))", borderRadius: "var(--radius-lg) var(--radius-lg) 0 0" }}>
              <Button variant="primary" size="lg" block icon="printer" loading={anlegen.isPending} onClick={() => void anlegenUndDrucken()}>{anzahl} Artikel anlegen und Etiketten drucken</Button>
            </div>
          </div>
        );
      }}
    </Seitenzustand>
  );
}
